import useMutationApi from 'src/api/useMutationApi';
import {
  GenerateUploadUrlRequest,
  GenerateUploadUrlResponse,
} from 'src/types/UserDocuments';

const useGenerateUploadUrl = () => {
  return useMutationApi<GenerateUploadUrlRequest, GenerateUploadUrlResponse>({
    endpoint: 'core/documents/upload-url',
    method: 'POST',
    showSuccessToast: false,
  });
};

export default useGenerateUploadUrl;
